import { graphql } from 'graphql-schema';

export const TEAM_ROSTER_RSVPS_FRAGMENT = graphql(`
  fragment TeamRosterRsvps on game_teams @_unmask {
    _id
    rsvps {
      _id
      user
      response
    }
  }
`);

export const TEAM_ROSTER_QUERY = graphql(
  `
    query TeamRoster($teamId: uuid!, $gameId: uuid!) {
      game_teams(where: { game: { _eq: $gameId }, team: { _eq: $teamId } }, limit: 1) {
        _id
        gameByGame {
          _id
          start_time
          end_time
        }
        teamByTeam {
          _id
          captain_user
          co_captains {
            _id
            user
          }
          players {
            _id
            user
            display_name_teams
          }
        }
        ...TeamRosterRsvps
      }
    }
  `,
  [TEAM_ROSTER_RSVPS_FRAGMENT]
);
